<template>
  <section v-if="inspection.side === 'arrival'" class="mt-4" data-testid="zone-review">
    <p v-if="state.checked" role="status" data-testid="zone-reviewed">
      {{ $t('damage_control.review.checked') }}<span v-if="outcomeKey"> — {{ $t(outcomeKey) }}</span>
    </p>
    <v-btn v-if="inspection.status === 'in_progress'" color="primary" class="dc-review-button"
           data-testid="review-zone" :loading="busy" :disabled="!state.available || state.checked || disabled || refreshRequired" @click="review">
      {{ $t('damage_control.review.checked') }}
    </v-btn>
    <p v-if="state.reason" class="mt-2" role="status" data-testid="zone-review-reason">{{ $t(state.reason) }}</p>
    <p v-if="errorText" role="alert" data-testid="zone-review-error">{{ errorText }}</p>
    <v-btn v-if="refreshRequired" outlined data-testid="zone-review-refresh" :loading="busy" @click="refresh">{{ $t('damage_control.capture.refresh') }}</v-btn>
  </section>
</template>

<script>
import { damageControlApi, reportDamageControlFailure } from "@/api/damageControl";
import { zoneReviewState, REVIEW_OUTCOME_KEYS } from "@/utils/damageControlReview";

import reviewRefreshMixin from "@/components/dashboard/damage_control/review/reviewRefreshMixin";

export default {
  name: "ZoneReviewControl",
  mixins: [reviewRefreshMixin],
  props: {
    inspection: { type: Object, required: true },
    zone: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() { return { refreshedInspection: null }; },
  computed: {
    activeInspection() { return this.refreshedInspection || this.inspection; },
    activeZone() { return (this.activeInspection.zones || []).find(zone => zone.key === this.zone.key) || this.zone; },
    state() { return zoneReviewState(this.activeZone, this.activeInspection.side); },
    outcomeKey() { return REVIEW_OUTCOME_KEYS[this.state.outcome]; },
  },
  watch: {
    inspection() { this.refreshedInspection = null; },
  },
  methods: {
    applyRefreshedInspection(payload) {
      this.refreshedInspection = payload;
      this.refreshRequired = false;
      this.$emit("update:inspection", payload);
    },
    async review() {
      if (this.busy || this.disabled || this.refreshRequired || !this.state.available || this.state.checked || this.activeInspection.status !== "in_progress") return;
      this.busy = true;
      this.errorText = "";
      try {
        await damageControlApi.reviewZone(this.axios, this.inspection.id, this.zone.key);
        this.refreshRequired = true;
        await this.reload();
      } catch (error) {
        // Refusals contain only a code. Re-read first, then explain from current client state.
        this.refreshRequired = true;
        try { await this.reload(); } catch (_) { /* Keep a retry when the GET fails. */ }
        this.errorText = this.state.reason ? this.$t(this.state.reason) : reportDamageControlFailure(this, error, { silent: true });
      } finally { this.busy = false; }
    },
  },
};
</script>

<style scoped>
@media (max-width: 599px) { section .v-btn { width: 100%; } }
</style>
